import { useContext, useEffect } from 'react';

import { ArticleContext } from '../Article.context';
import styles from '../article.module.css';

export const StyledText = (props: StyledTextProps) => {
    const {
        id,
        text,
        text_lang,
        expandfullwidth,
        bleed,
        dropcap,
        component,
        imageurl,
        imagemargin,
        imagewidth,
        imagefloat,
        imageenabled,
        IMAGECAPTION,
        unit,
        style
    } = props;
    const { lang } = useContext(ArticleContext);
    let content = text;
    if (lang && text_lang?.[lang]) {
        content = text_lang[lang];
    }

    return (
        <Text
            id={id}
            bleed={bleed === 'on'}
            text={content}
            imageCaption={IMAGECAPTION}
            dropcap={dropcap === 'on'}
            expandFullWidth={expandfullwidth === 'on'}
            imageUrl={imageurl}
            unit={unit}
            imageMargin={`${imagemargin}`}
            imageWidth={`${imagewidth}`}
            imageFloat={`${imagefloat}`}
            imageEnabled={imageenabled === 'on'}
            type={component}
            style={style}
        />
    );
};

interface StyledTextProps {
    id: string;
    text: string;
    unit: any;
    IMAGECAPTION: string;
    column: boolean;
    imageurl: string;
    imageenabled: string;
    imagemargin: string | number;
    imagewidth: string | number;
    imagefloat: string | number;
    text_lang: any;
    expandfullwidth: string;
    bleed: string;
    dropcap: string;
    columnStyle: any;
    component: string;
    style: any;
}

StyledText.defaultProps = {
    column: false,
    columnStyle: null,
};

export const Text = (props: TextProps) => {
    const {
        id,
        bleed = false,
        text,
        expandFullWidth = false,
        type,
        dropcap = false,
        imageUrl,
        style,
        imageWidth,
        imageFloat,
        imageEnabled,
        imageCaption,
        unit,
    } = props;

    let {imageMargin} = props
    

    const { onEventSend } = useContext(ArticleContext);
    const css = [];
    let image = '';
    let clearer = '';
    const componentStyle: any = {};
    
    if (expandFullWidth) {
        componentStyle.minWidth = '100%';
        componentStyle.width = '100%';
    }

    if(style && style['unit']) {
        const unit = style['unit'];
        if(style['margin_top'] && unit['margin_top']) {
            componentStyle.marginTop = `${style['margin_top']}${unit['margin_top']}`
        }
        if(style['margin_left'] && unit['margin_left']) {
            componentStyle.marginLeft = `${style['margin_left']}${unit['margin_left']}`
        }
        if(style['margin_right'] && unit['margin_right']) {
            componentStyle.marginRight = `${style['margin_right']}${unit['margin_right']}`
        }
        if(style['margin_bottom'] && unit['margin_bottom']) {
            componentStyle.marginBottom = `${style['margin_bottom']}${unit['margin_bottom']}`
        }
        if(style['padding_top'] && unit['padding_top']) {
            componentStyle.paddingTop = `${style['padding_top']}${unit['padding_top']}`
        }
        if(style['padding_left'] && unit['padding_left']) {
            componentStyle.paddingLeft = `${style['padding_left']}${unit['padding_left']}`
        }
        if(style['padding_right'] && unit['padding_right']) {
            componentStyle.paddingRight = `${style['padding_right']}${unit['padding_right']}`
        }
        if(style['padding_bottom'] && unit['padding_bottom']) {
            componentStyle.paddingBottom = `${style['padding_bottom']}${unit['padding_bottom']}`
        }
    }

 

    useEffect(() => {
        setTimeout(() => {
            document.querySelectorAll(`#${id} a`).forEach((elem: any) => {
                if (elem.target === '_blank' && elem.href) {
                    elem.onclick = () => {
                        onEventSend({
                            event: 'external',
                            data: {
                                url: elem.href,
                                componentId: id,
                                componentType: type,
                            },
                        });
                    };
                }
            });
        }, 500);
    }, [type, onEventSend, id]);

    if (text === '<p></p>') {
        return null;
    }


    if (imageEnabled) {
        if (imageFloat === 'left') {
            imageMargin = `
				margin-right: ${imageMargin}px;
				margin-bottom: ${imageMargin}px;
			`;
        } else {
            imageMargin = `
			margin-left: ${imageMargin}px;
			margin-bottom: ${imageMargin}px;
		`;
        }
        const imageWidthUnit = unit?.['imagewidth'] || 'px';
        css.push(`#${id} figure {
			max-width: ${imageWidth}${imageWidthUnit};
			float: ${imageFloat};
			${imageMargin}
		}`);
        css.push(`#${id} img {
			width: 100%;
		}`);
        if (imageUrl) {
            const caption = imageCaption
                ? `<figcaption>${imageCaption}</figcaption>`
                : '';
            componentStyle.display = 'block';
            image = `<figure><img src="${imageUrl}" />${caption}</figure>`;
            clearer = '<span style="display: block; clear: both;"></span>';
        }
    }

    const classNames = ['component', 'text', type, styles['component']];
    if (bleed) {
        classNames.push('bleed');
    }

    if (dropcap) {
        classNames.push('dropcap');
    }

    return (
        <>
            <div
                id={id}
                style={componentStyle}
                className={classNames.join(' ')}
                dangerouslySetInnerHTML={{
                    __html: `${image} ${text} ${clearer}`,
                }}
            />
            <style>{css.join('\n')}</style>
        </>
    );
};

interface TextProps {
    id?: string;
    imageCaption?: string;
    unit?: any;
    bleed?: boolean;
    text?: any | string;
    expandFullWidth?: boolean;
    css?: string;
    imageEnabled?: boolean;
    imageUrl?: string;
    imageMargin?: string;
    imageFloat?: string;
    imageWidth?: string;
    style?: any;
    container?: any;
    dropcap?: boolean;
    type?: string;
}
